// ras 订阅的逻辑
import {combineLatest, BehaviorSubject} from 'rxjs';
import {filter, map, scan, startWith} from 'rxjs/operators';
import {rasMsgSubUsers$} from '@/raw/ras-all';
import {contractSubUserIds$} from '@/raw/users';
import {calcRasBalance} from '../ras';
import {wsLogout$} from '@/user/auth-ws';

const rawUsdtAccountSubUsers$ = combineLatest([rasMsgSubUsers$, contractSubUserIds$]).pipe(
  filter(([{userId}, userIds]) => userIds.includes(userId)),
  map(([{userId, data}]) => {
    return function (cache) {
      const {valuationCurrency} = data.risk_units.find((o) => !o.symbol) || {valuationCurrency: ''};
      cache.set(userId, calcRasBalance(data.risk_units, valuationCurrency));
      return cache;
    };
  }),
  scan((p, action) => action(p), new Map()),
  startWith(new Map())
);

export const usdtAccountSubUsers$ = new BehaviorSubject(new Map());

rawUsdtAccountSubUsers$.subscribe(usdtAccountSubUsers$);
wsLogout$.subscribe(() => usdtAccountSubUsers$.next(new Map()));
